import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    title: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 21,
        letterSpacing: 0.7,
        flex: 1
    },
    itemCount: {
        color: Theme.secondaryTextColor
    },
    content: {
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: 10
    },
    header: {
        flexDirection: 'row',
        marginBottom: 15
    },
    button: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 5
    },
    buttonText: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 18,
        letterSpacing: 0.7
    },
    buttonIcon: {
        width: 20,
        height: 20,
        marginStart: 10
    },
    packshot: {
        marginRight: 14,
        marginBottom: 10
    },
    firstPackshot: {},
    hidden: {
        height: 0,
        width: 0
    },
    indicator: {
        flex: 1,
        height: 50
    },
    leftArrow: {
        position: 'absolute',
        left: -32,
        height: '100%',
        justifyContent: 'center'
    },
    rightArrow: {
        position: 'absolute',
        right: -32,
        height: '100%',
        justifyContent: 'center'
    }
};

export default StyleSheet.create(baseStyles);
